"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabuLookUp = exports.ProcedureIDs = exports.TabuRequestStatusType = void 0;
var TabuRequestStatusType;
(function (TabuRequestStatusType) {
    TabuRequestStatusType[TabuRequestStatusType["ENTERED"] = 1] = "ENTERED";
    TabuRequestStatusType[TabuRequestStatusType["PENDING_PAYMENT"] = 2] = "PENDING_PAYMENT";
    TabuRequestStatusType[TabuRequestStatusType["PAID"] = 3] = "PAID";
    TabuRequestStatusType[TabuRequestStatusType["COMPLETED"] = 4] = "COMPLETED";
    TabuRequestStatusType[TabuRequestStatusType["REJECTED"] = 5] = "REJECTED";
    TabuRequestStatusType[TabuRequestStatusType["CANCELLED"] = 6] = "CANCELLED";
    TabuRequestStatusType[TabuRequestStatusType["UNDER_AUDIT"] = 7] = "UNDER_AUDIT";
})(TabuRequestStatusType = exports.TabuRequestStatusType || (exports.TabuRequestStatusType = {}));
var ProcedureIDs;
(function (ProcedureIDs) {
    ProcedureIDs[ProcedureIDs["ELECTRONIC_TITLE_DEED"] = -1] = "ELECTRONIC_TITLE_DEED";
    ProcedureIDs[ProcedureIDs["LOSS_CERTIFICATE"] = 19] = "LOSS_CERTIFICATE";
    ProcedureIDs[ProcedureIDs["SITE_PLAN"] = 20] = "SITE_PLAN";
    ProcedureIDs[ProcedureIDs["PROPERTY_VALUATION"] = 24] = "PROPERTY_VALUATION";
    ProcedureIDs[ProcedureIDs["INTERNAL_PROPERTY_VALUATION"] = 29] = "INTERNAL_PROPERTY_VALUATION";
    ProcedureIDs[ProcedureIDs["TO_WHOM_CONCERN"] = 125] = "TO_WHOM_CONCERN";
    ProcedureIDs[ProcedureIDs["PROPERTY_DETAIL_CERT"] = 225] = "PROPERTY_DETAIL_CERT";
    ProcedureIDs[ProcedureIDs["BCS_RE_CLASSIFICATION"] = 950] = "BCS_RE_CLASSIFICATION";
    ProcedureIDs[ProcedureIDs["OWNERSHIP_CHANGE"] = 18] = "OWNERSHIP_CHANGE";
    ProcedureIDs[ProcedureIDs["PROPERTY_CUT_OFF"] = 3] = "PROPERTY_CUT_OFF";
    ProcedureIDs[ProcedureIDs["DELAYED_PROPERTY_CUT_OFF"] = 213] = "DELAYED_PROPERTY_CUT_OFF";
    ProcedureIDs[ProcedureIDs["PROPERTY_ANNEX"] = 2] = "PROPERTY_ANNEX";
    ProcedureIDs[ProcedureIDs["DELAYED_PROPERTY_ANNEX"] = 216] = "DELAYED_PROPERTY_ANNEX";
    ProcedureIDs[ProcedureIDs["CONVERT_TO_FREEHOLD"] = 50] = "CONVERT_TO_FREEHOLD";
})(ProcedureIDs = exports.ProcedureIDs || (exports.ProcedureIDs = {}));
var TabuLookUp;
(function (TabuLookUp) {
    TabuLookUp["LOST_CERTIFICATE_TYPES"] = "lostCertificateTypes";
    TabuLookUp["REQUIRED_DOCUMENTS"] = "requiredDocuments";
    TabuLookUp["GENDER"] = "gender";
    TabuLookUp["COUNTRIES"] = "countries";
    TabuLookUp["LANGUAGES"] = "languages";
    TabuLookUp["RESIDENT_PERSON_DOCUMENTS"] = "residentpersondocuments";
    TabuLookUp["NATIONAL_PERSON_DOCUMENTS"] = "nationalpersondocuments";
    TabuLookUp["VISITOR_PERSON_DOCUMENTS"] = "otherpersondocuments";
    TabuLookUp["EMIRATES"] = "emirates";
    TabuLookUp["OWNERSHIP_CHANGE_DOCUMENTS"] = "ownershipchangedocuments";
    TabuLookUp["CUT_OFF_DOCUMENTS"] = "cutoffdocuments";
    TabuLookUp["DELAYED_CUT_OFF_DOCUMENTS"] = "delayedcutoffdocuments";
    TabuLookUp["PROPERTY_ANNEX_DOCUMENTS"] = "PropertyAnnexationdocuments";
    TabuLookUp["DELAYED_PROPERTY_ANNEX_DOCUMENTS"] = "DelayedPropertyAnnexdocuments";
    TabuLookUp["CONVERT_TO_FREEHOLD"] = "ConvertToFreeholdproceduredocuments";
})(TabuLookUp = exports.TabuLookUp || (exports.TabuLookUp = {}));
